import { render, staticRenderFns } from "./ScheduleStandartTimeSelector.vue?vue&type=template&id=d10d5284&scoped=true"
import script from "./ScheduleStandartTimeSelector.vue?vue&type=script&lang=js"
export * from "./ScheduleStandartTimeSelector.vue?vue&type=script&lang=js"
import style0 from "./ScheduleStandartTimeSelector.vue?vue&type=style&index=0&id=d10d5284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10d5284",
  null
  
)

export default component.exports